import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import AboutSection from "./components/AboutSection";
import HowItWorksSection from "./components/HowItWorksSection";
import GallerySection from "./components/GallerySection";
import ReviewsSection from "./components/ReviewsSection";
import HoursLocationSection from "./components/HoursLocationSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import MobileBottomBar from "./components/MobileBottomBar";

export default function Home() {
  return (
    <div className="pb-20 md:pb-0">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <GallerySection />
        <HowItWorksSection />
        <ReviewsSection />
        <HoursLocationSection />
        <CTASection />
      </main>
      <Footer />
      <MobileBottomBar />
    </div>
  );
}